import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blobToImage',
  standalone: false,
})
export class BlobToImagePipe implements PipeTransform {
  transform(value: Blob): string {
    return URL.createObjectURL(value);
  }
}
